let serverContext = null;

export const setServerContext = context => {
  serverContext = context;
};

export const getServerContext = () => serverContext;
